module.exports = __webpack_public_path__ + "img/ATA.70a652bc.svg";